import { memo } from 'react'
import { isEqual } from 'lodash'
import { PageTitle } from 'app/components/common/PageTitle'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import UpdateWarehousePurchaseContainer from 'app/containers/InventoryManagement/WarehousePurchase/pages/update'

const UpdateWarehousePurchaseContainerPageCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.inventory_management)}</PageTitle>
      <UpdateWarehousePurchaseContainer />
    </>
  )
}
const UpdateWarehousePurchaseContainerPage = memo(
  UpdateWarehousePurchaseContainerPageCpn,
  isEqual,
)

export default UpdateWarehousePurchaseContainerPage
